import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { authToken } from 'config/axios';
import { catchAsync } from 'helpers';

export const register = createAsyncThunk(
  'auth/register',
  catchAsync(async (credentials, thunkAPI) => {
    const res = await axios.post('/auth/register', credentials);
    authToken.set(res.data.token);
    return res.data;
  })
);
